import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useGetIdentity, useLogout } from '@refinedev/core';
import { maskPhone } from '@shared/lib/mask-phone';
import { Avatar, Dropdown, Modal, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import type { UserResponse } from '@api/generated/types.gen';

const { Text } = Typography;

/**
 * Меню пользователя в шапке: аватар + dropdown с logout.
 *
 * Телефон отображается замаскированно (`+7999*****67`), чтобы не светить
 * PII в скриншотах и записях скринкастов.
 */
export function UserMenu() {
  const { t } = useTranslation(['common', 'auth']);
  const { data: user } = useGetIdentity<UserResponse>();
  const { mutate: logout } = useLogout();

  const phone = user?.phone ?? '';
  const initials = phone ? phone.slice(-2) : 'AD';

  const confirmLogout = (): void => {
    Modal.confirm({
      title: t('auth:logout.confirmTitle'),
      content: t('auth:logout.confirmText'),
      okText: t('common:actions.logout'),
      cancelText: t('common:actions.cancel'),
      okButtonProps: { danger: true },
      onOk: () => {
        logout();
      },
    });
  };

  return (
    <Dropdown
      menu={{
        items: [
          {
            key: 'phone',
            label: (
              <Space direction="vertical" size={0} style={{ padding: '4px 0' }}>
                <Text style={{ fontSize: 12, color: '#64748B' }}>
                  <UserOutlined style={{ marginInlineEnd: 4 }} />
                  {t('common:menu.dashboard')}
                </Text>
                <Text style={{ fontFamily: '"JetBrains Mono", monospace', fontSize: 13 }}>
                  {maskPhone(phone)}
                </Text>
              </Space>
            ),
            disabled: true,
          },
          { type: 'divider' },
          {
            key: 'logout',
            label: t('common:user.menu.logout'),
            icon: <LogoutOutlined />,
            danger: true,
            onClick: confirmLogout,
          },
        ],
      }}
      trigger={['click']}
      placement="bottomRight"
    >
      <button
        type="button"
        style={{
          border: 'none',
          background: 'transparent',
          padding: 4,
          borderRadius: 6,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
        aria-label="User menu"
      >
        <Avatar
          size={32}
          style={{
            background: '#F1F5F9',
            color: '#0F172A',
            fontWeight: 600,
            fontSize: 12,
            fontFamily: '"JetBrains Mono", monospace',
          }}
        >
          {initials}
        </Avatar>
      </button>
    </Dropdown>
  );
}
